import request from '@/axios'
//course/create/2
export function createCourse (payload, customer_id) {
  return request({
    url:`/course/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}

// api/lesson/create/2

export function createLesson (payload, customer_id) {
  return request({
    url:`/lesson/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}
//api/topic/create/2
export function createTopic (payload, customer_id) {
  return request({
    url:`/topic/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}

// http://localhost:8000/api/topic/create/2

export function courseListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/course/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function newcourseListing (customer_id, payload, queryParams = 1, sorting_obj, table_name) {
  let url = `V1/course/list/${customer_id}?table_name=${table_name}&page=${queryParams}`
  if (Object.entries(sorting_obj).length > 0) {
    url = `V1/course/list/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${queryParams}`
  }
  return request({
    url,
    method:'POST',
    data:payload
  })
}


export function lessonListing (customer_id, payload, queryParams = 1, query) {
  return request({
    url:`/lesson/list/${customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function topicListing (customer_id, payload, queryParams = 1) {
  return request({
    url:`/topic/list/${customer_id}?page=${queryParams}`,
    method:'POST',
    data:payload
  })
}

export function ChangeLessonStatus (customer_id, payload) {
  return request({
    url:`/lesson/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function changeCourseStatus (customer_id, payload) {
  return request({
    url:`/course/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function changeTopicStatus (customer_id, payload) {
  return request({
    url:`/topic/change-status/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function deleteCourse (customer_id, payload) {
  return request({
    url:`/course/delete/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function deleteLesson (customer_id, payload) {
  return request({
    url:`/lesson/delete/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function deleteTopic (customer_id, payload) {
  return request({
    url:`/topic/delete/${customer_id}`,
    method:'POST',
    data:payload
  })


}
export function contentFileUpload (customer_id, payload) {
  return request({
    url:`/file/upload/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function deleteAssignmentOrQuesion (customer_id, payload) {
  return request({
    url:`/course/remove-assignment-or-question/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function saveCourseSettings (customer_id, payload) {
  return request({
    url:`/course/setting/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function courseShare (platform_customer_id, payload) {
  // http://localhost:8000/api/course/share/2
  return request({
    url:`/course/share/${platform_customer_id}`,
    method:'POST',
    data:payload


  })

}

export function coursePreview (course_slug) {
  // http://localhost:8000/api/course/share/2
  return request({
    url:`/course/preview/${course_slug}`,
    method:'POST'
  })

}

export function submitCourseInterestapi (payload, customer_id) {
  // http://localhost:8000/api/course/share/2
  return request({
    url:`/course/enroll/${customer_id}`,
    method:'POST',
    data:payload
  })

}

//equipmenets
export function getCourseEquipment (customer_id) {
  // http://localhost:8000/api/course/share/2
  return request({
    url:`course/equipments/${customer_id}`,
    method:'GET'

  })

}


export function saveCourseEquipment (payload, customer_id) {
  // http://localhost:8000/api/course/share/2
  return request({
    url:`course/equipments/${customer_id}`,
    method:'POST',
    data:payload
  })

}


//enrollment

export function enrollmentApi (payload, customer_id) {

  return request({
    url:`course/enroll/multiple/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function getStudentShortList (customer_id) {
  return request({
    url:`clientUser/list/short/${customer_id}`,
    method:'GET'
  })


}

export function getTimingOneToOneTeacher (payload) {
  return request({
    url:'schedule/timing/one-2-one',
    method:'POST',
    data:payload
  })
}

export function enrolledCourseList (customer_id, payload) {
  return request({
    url:`course/enrolled/student/course_list/${customer_id}`,
    method:'POST',
    data:payload
  })
}

//enrollment

// http://localhost:8000/api/course/equipments/2
// {
//     "course_id": 38,
//     "asset_type_id": 1,
//     "no_of_equipment": 2
// }

// http://localhost:8000/api/course/remove-assignment-or-question/2
